var _path, _path2, _path3, _path4, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSendEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.369141 3.70833C0.369141 3.31713 0.694618 3 1.09611 3H10.5468V4.41667H1.82309V18.5833H22.1784V8.66667H23.6323V19.2917C23.6323 19.6829 23.3068 20 22.9053 20H1.09611C0.694618 20 0.369141 19.6829 0.369141 19.2917V3.70833Z",
    fill: "#0E4C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.423151 3.42237C0.532931 3.1667 0.791552 3 1.07842 3H10.2988V4.36842H2.79073L11.7173 12.9797L15.4714 9.3583L16.4744 10.3259L12.2188 14.4312C11.9419 14.6984 11.4928 14.6984 11.2158 14.4312L0.576899 4.16802C0.374052 3.97234 0.313371 3.67805 0.423151 3.42237Z",
    fill: "#0E4C54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31651 12.0701L1.38842 19.9981L0.369141 18.9789L8.29723 11.0508L9.31651 12.0701Z",
    fill: "#0E4C54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7048 11.0508L23.6329 18.9789L22.6136 19.9981L14.6855 12.0701L15.7048 11.0508Z",
    fill: "#0E4C54"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 3,
    width: 9,
    height: 3,
    rx: 1.5,
    fill: "#0E4C54"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.166,
    width: 6.64149,
    height: 2.49056,
    rx: 1.24528,
    transform: "rotate(45 19.166 0)",
    fill: "#0E4C54"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4062,
    y: 8.01562,
    width: 6.64149,
    height: 2.49056,
    rx: 1.24528,
    transform: "rotate(-45 17.4062 8.01562)",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendEmail);
export default __webpack_public_path__ + "static/media/icon-send-email.bfcc4dc42d1fc0a2da39dbfd5c4899f6.svg";
export { ForwardRef as ReactComponent };